export interface LanguageInterface {
  id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  key?: string;
  nativeName?: string;
  settingsLanguage: boolean;
}
